import { updateImage } from 'api'
import { ItemDataAssentsAll, UpdateImageResponse } from 'interfaces'
import dayjs from 'lib/dayjs'
import { PixelCrop } from 'react-image-crop'
import { configGenaral } from 'utils'

export const handleUploadImage = (
	file: File,
	setListImage: (
		updater: (prevState: ItemDataAssentsAll[]) => ItemDataAssentsAll[]
	) => void,
	setAspectString: (value: string | undefined) => void,
	setIsCropped: (value: boolean) => void,
	resetCropState: () => void,
	showToast: (message: string) => void
): void => {
	const fileSize = file.size
	const fileMb = fileSize / 1024 ** 2
	if (fileMb < configGenaral.maxfileSizeMB) {
		const render = new FileReader()
		render.onload = e => {
			const uploadedObj = { file, url: e.target?.result as string }
			setListImage(prevState => [
				...prevState,
				{
					asset_type: 'image',
					asset_url: uploadedObj.url,
					asset_name: `${dayjs().format('YYYYMMDDHHmmss')}-${
						uploadedObj.file.name
					}`
				}
			])
			setAspectString(undefined)
		}
		render.readAsDataURL(file)
	} else {
		showToast(
			`Please select a file less than ${configGenaral.maxfileSizeMB}MB.`
		)
		setIsCropped(true)
	}
	resetCropState()
}

export const handleFinishCrop = (
	refCanva: React.RefObject<HTMLCanvasElement>,
	aspectString: string | undefined,
	listImage: ItemDataAssentsAll[],
	completedCrop?: PixelCrop | null
): ItemDataAssentsAll => {
	if (completedCrop && refCanva.current) {
		const canvas = refCanva.current
		const resizedCanvas = document.createElement('canvas')
		const resizedCtx = resizedCanvas.getContext('2d')

		if (aspectString === '1/1') {
			resizedCanvas.width = 1080
			resizedCanvas.height = 1080
			if (resizedCtx !== null) {
				resizedCtx.imageSmoothingEnabled = false
				resizedCtx.drawImage(canvas, 0, 0, 1080, 1080)
			}
		} else if (aspectString === '1/1.2941') {
			resizedCanvas.width = 1080
			resizedCanvas.height = 1398
			if (resizedCtx !== null) {
				resizedCtx.imageSmoothingEnabled = false
				resizedCtx.drawImage(canvas, 0, 0, 1080, 1398)
			}
		} else {
			resizedCanvas.width = 1920
			resizedCanvas.height = 1080
			if (resizedCtx !== null) {
				resizedCtx.imageSmoothingEnabled = false
				resizedCtx.drawImage(canvas, 0, 0, 1920, 1080)
			}
		}

		const resizedImageData = resizedCanvas.toDataURL('image/jpeg', 0.85)

		const updatedListImage = [...listImage]
		updatedListImage[updatedListImage.length - 1].asset_url = resizedImageData
		const fileName = listImage[listImage.length - 1].asset_name

		const newImage = {
			asset_type: 'image',
			asset_url: resizedImageData,
			asset_name: `${dayjs().format('YYYYMMDDHHmmss')}-${fileName}`,
			asset_aspect: aspectString
		}
		return newImage
	}
	return {
		asset_type: 'image',
		asset_url: '',
		asset_name: '',
		asset_aspect: ''
	}
}

export const updatePhoto = async (
	imageFile: string,
	credentials: UpdateImageResponse | null,
	nameImage: string
): Promise<string> => {
	if (!credentials) return ''
	if (
		imageFile.includes('s3.amazonaws.com') ||
		imageFile.includes('cloudfront.net')
	)
		return imageFile
	const getImage = await fetch(imageFile)
	const imageBlob = await getImage.blob()
	const newKey = credentials.fields.key.replace(
		// eslint-disable-next-line no-template-curly-in-string
		'${filename}',
		`${Date.now()}-${nameImage}`
	)
	const body = {
		...credentials.fields,
		file: imageBlob,
		key: newKey
	}
	await updateImage(credentials.url, body)
	const url = `${credentials.url}${newKey}`
	return url
}
